import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { ISurvey } from "../../../../../@types/Surveys";
import { IWardOption } from "../../../../../@types/User";
import { Button } from "../../../../../components/Button";
import { Toggle } from "../../../../../components/Toggle";
import { useWardLabel } from "../../../../../hooks/useWardLabel";
import { surveysService } from "../../../../../services/surveysService";
import { CancelButton } from "../../../../Settings/components/SecurityModal/SecurityModal.styles";
import { HandleQuestionFormContainer } from "../../../SurveyBuilder/Components/ContentTab/Components/AddQuestionModal/AddQuestionModal.styles";
import { AssignHospitalModalContainer, Title } from "./AssignToHospital.styles";
import { HospitalListTable } from "./HospitalListTable/HospitalListTable";

interface IAssignToHospitalModalProps {
  onClose(): void;
  survey: ISurvey;
  refetch(): void;
}

export function AssignToHospitalModal({
  onClose,
  survey,
  refetch,
}: IAssignToHospitalModalProps) {
  const { t } = useTranslation();

  const wardLabel = useWardLabel();
  const [hospitalsToAssignList, setHospitalsToAssign] = useState<number[]>([]);
  const [hospitalObjectList, setHospitalObjectList] = useState<IWardOption[]>();
  const [loading, setLoading] = useState<boolean>(true);
  const [surveyId, setSurveyId] = useState<string>("");
  const [tableContent, setTableContent] = useState<any>([]);

  const parseDataToHospitalTable = (data: IWardOption[]) => {
    const formatttedDataTable: any[] = [];
    data.map((hospital: IWardOption, index: number) =>
      formatttedDataTable.push({
        hospitalName: hospital.wardName,
        hospitalId: hospital.wardId,
        action: (
          <div>
            <Toggle
              defaultChecked={hospitalsToAssignList.includes(hospital.wardId)}
              onCheckedChange={(isChecked) => {
                const updatedHospitalsToAssign = [...hospitalsToAssignList];
                if (isChecked) {
                  updatedHospitalsToAssign.push(data[index].wardId);
                } else {
                  const indexToRemove = updatedHospitalsToAssign.findIndex(
                    (element) => element === hospital.wardId
                  );
                  updatedHospitalsToAssign.splice(indexToRemove, 1);
                }
                setHospitalsToAssign(updatedHospitalsToAssign);
              }}
            />
          </div>
        ),
      })
    );
    return formatttedDataTable;
  };
  useEffect(() => {
    (async () => {
      const { data } = await surveysService.getAllHospitals();
      setHospitalObjectList(data);

      if (survey.wardIds) setHospitalsToAssign(survey.wardIds);
      if (survey.id) setSurveyId(survey.id);
    })();
  }, []);

  useEffect(() => {
    if (hospitalObjectList && hospitalsToAssignList) {
      setTableContent(parseDataToHospitalTable(hospitalObjectList));
      setLoading(false);
    }
  }, [hospitalObjectList, hospitalsToAssignList]);

  const handleHospitalAssignment = async () => {
    await surveysService.assignSurveyToWards(surveyId, hospitalsToAssignList);
    refetch();
  };

  return (
    <AssignHospitalModalContainer>
      <Title>
        {t("surveys_list_assignWard", { ward: wardLabel.singularLower })}
      </Title>
      <HospitalListTable isLoading={loading} content={tableContent} />
      <HandleQuestionFormContainer>
        <Button
          label={t("surveys_assignToHospital_save")}
          type="button"
          onClick={() => {
            handleHospitalAssignment();
            onClose();
          }}
        />

        <CancelButton
          style={{
            border: "2px solid rgba(248, 248, 248, 0.8)",
            backgroundColor: "rgba(248, 248, 248, 0.8)",
          }}
          onClick={onClose}
        >
          {t("common_cancel")}
        </CancelButton>
      </HandleQuestionFormContainer>
    </AssignHospitalModalContainer>
  );
}
